import { defineComponent as _defineComponent } from 'vue'
import Icon from 'JS/components/Icon.vue';
import { computed, ref } from 'vue';
import { IWebSiteMenu, MenuLinkType } from 'Src/js/types/Header';


export default /*#__PURE__*/_defineComponent({
  __name: 'MegaMenuDepartment',
  props: {
    menuItem: null,
    currentDepth: null,
    maxDepth: null
  },
  setup(__props: any) {

const props = __props as {
	menuItem: IWebSiteMenu,
	currentDepth: number,
	maxDepth: number,
}



const activeMenuId = ref<string>("");

const atFinalDepth = computed(()=> {
	return props.currentDepth >= props.maxDepth;
});

function toggleDepartment(departmentId: string) {
	activeMenuId.value = activeMenuId.value !== departmentId ? departmentId : "";
}

function handleMenuClick(menuLevel: number, menuLinkType: MenuLinkType = 'other') {
	window.blainGtmDataLayer.push({
		'menuName': "main",
		'menuLevel': menuLevel,
		'menuLinkType': menuLinkType,
		'event': "menu_click"
	});
}


return { __sfc: true,props, activeMenuId, atFinalDepth, toggleDepartment, handleMenuClick, Icon }
}

})